import {
  CANONICAL_ORIGIN,
  ImageSet,
  cardImage,
  touristAttraction,
} from './shared'

// The adventure detail data. SSR seeds the redux adventure (`url`/`photos`); the
// client GraphQL path uses `shareUrl` and omits photos, hence the fallbacks.
export interface DetailAdventure {
  title?: string | null
  description?: string | null
  url?: string | null
  shareUrl?: string | null
  location?: { lat?: number | null; lng?: number | null } | null
  photos?: Array<{ image?: ImageSet | null } | null> | null
}

// The adventure detail page as a schema.org TouristAttraction.
export const adventureJsonLd = (
  adventure: DetailAdventure | null | undefined,
  { origin = CANONICAL_ORIGIN }: { origin?: string } = {},
) => {
  const attraction =
    adventure &&
    touristAttraction(
      {
        url: adventure.url || adventure.shareUrl,
        name: adventure.title,
        image: cardImage(adventure.photos?.[0]?.image),
        description: adventure.description,
        location: adventure.location,
      },
      origin,
    )

  return attraction ? { '@context': 'https://schema.org', ...attraction } : null
}
